// Generated by ReScript, PLEASE EDIT WITH CARE


function languageFromString(value) {
  switch (value) {
    case "de" :
        return "German";
    case "en" :
        return "English";
    default:
      return "English";
  }
}

function languageToString(lang) {
  if (lang === "English") {
    return "en";
  } else {
    return "de";
  }
}

function translateTo(lang, entry) {
  if (lang === "English") {
    return entry.en;
  } else {
    return entry.de;
  }
}

var Labels_projects = {
  en: "Projects",
  de: "Projekte"
};

var Labels_aboutMe = {
  en: "About Me",
  de: "Über Mich"
};

var Labels = {
  projects: Labels_projects,
  aboutMe: Labels_aboutMe
};

var AboutMePage_helloImBen = {
  en: "Hi! I'm Ben Faerber.",
  de: "Moin! Ich bin Ben Faerber."
};

var AboutMePage_paragraph1 = {
  en: "I made this site to show off some of my projects and share some interesting concepts I have learned. I am very interested in functional programming (this site is written in Rescript, a compile to Javascript language based on OCaml's robust type system). I helped port Rescript React from React 17 to React 18. I love working on open source projects, running and baking sourdough! ",
  de: ""
};

var AboutMePage_paragraph2 = {
  en: "I am very interested in how we can abstract complex concepts into easily digestible pieces. How can we model real world data and should this data interact with the outside world? How does syntax affect the way we think about programming? How do the tools we choose affect the way we think about solving problems? How can we become better programmers? These are the questions I would like to look into.",
  de: ""
};

var AboutMePage_paragraph3 = {
  en: "I've been programming since about 2012, I started with a variant of ActionScript called GML. My first \"real\" language was C# in 2014. These days I mostly write server code (mainly Rust, OCaml, Typescript and PHP). I love to create just for the sake of creation.",
  de: ""
};

var AboutMePage_dummy = {
  en: "",
  de: ""
};

var AboutMePage = {
  helloImBen: AboutMePage_helloImBen,
  paragraph1: AboutMePage_paragraph1,
  paragraph2: AboutMePage_paragraph2,
  paragraph3: AboutMePage_paragraph3,
  dummy: AboutMePage_dummy
};

export {
  languageFromString ,
  languageToString ,
  translateTo ,
  Labels ,
  AboutMePage ,
}
/* No side effect */
